import { render } from "./WhatsappConfigBoard.vue?vue&type=template&id=833a6c54"
import script from "./WhatsappConfigBoard.vue?vue&type=script&lang=js"
export * from "./WhatsappConfigBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__